// extracted by mini-css-extract-plugin
module.exports = {"button-apple":"index__button-apple___XDByd","buttonApple":"index__button-apple___XDByd","text":"index__text___29Izi"};